import BaeMasterLayoutGuidesService
    from '@src/slide/application/service/guides-manager/base-master-layout-guides-service';
import { EUpdateGuidesType, IMasterLayoutGuides } from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model.interface';

/**
 * 母版参考线
 */
export default class MasterGuidesService extends BaeMasterLayoutGuidesService {
    public updateGuidesProps(): void {
        const masterGuides: Array<IMasterLayoutGuides> = this.getUpdateProps();
        this.guideModel?.updateGuidesPropsNoUndo({
            masterGuides,
            slideGuides: this.guideModel.slideGuides,
            layoutGuides: this.guideModel.layoutGuides,
        }, EUpdateGuidesType.master);
    }

    protected getId() {
        const model = this.selectionService.currentSlide?.getRelationMasterModel();
        const presentationModel = model?.presentationRef;
        if (presentationModel && model?.sdkData) {
            return presentationModel.getMasterChildrenMapKey(model.sdkData);
        }
    }

    protected isMaster() {
        return true;
    }
}
